import {NgModule} from '@angular/core';

import {TuiEditorSocketComponent} from './editor-socket.component';

@NgModule({
    declarations: [TuiEditorSocketComponent],
    exports: [TuiEditorSocketComponent],
})
export class TuiEditorSocketModule {}
